import React from 'react';
import { TIER_COLORS, defaultT } from './constants.js';

/**
 * TierBadge — Farb-Badge fuer Lizenz-Tier.
 */
export default function TierBadge({ tier, t = defaultT }) {
  const s = TIER_COLORS[tier] || { color: '#9ca3af', bg: '#f3f4f6' };
  return (
    <span style={{
      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10,
      color: s.color, background: s.bg, display: 'inline-block',
    }}>
      {t(`shared.license.tiers.${tier}`, tier)}
    </span>
  );
}
